import React from "react";
import { Switch, Route, useRouteMatch, Redirect } from "react-router-dom";
import Page, { Nav, NavGroup, NavItem, Content } from "shared/Page";
import { ReactComponent as ReportIcon } from "../shared/assets/Reporting_Menu_icon.svg";

import ReportsPage from "./ReportsPage";

export default function ReportsLayout() {
  const { path } = useRouteMatch();

  return (
    <Page>
      <Nav>
        <NavGroup title="IBO Reporting">
          <NavItem to={`${path}`} exact icon={<ReportIcon />}>
            Reports
          </NavItem>
          {/*
          <NavItem to={`${path}/saved`} exact icon={<SavedReportIcon />}>
            Saved Reports
          </NavItem>
          <NavItem to={`${path}/settings`} exact icon={<SettingsIcon />}>
            Settings
          </NavItem>
          */}
        </NavGroup>
      </Nav>

      <Content>
        <Switch>
          <Route exact path={path}>
            <ReportsPage />
          </Route>

          <Route path="*">
            <Redirect to={path} />
          </Route>
        </Switch>
      </Content>
    </Page>
  );
}
